import { render } from "./ModalCadExame.vue?vue&type=template&id=26152aaa&scoped=true"
import script from "./ModalCadExame.vue?vue&type=script&lang=js"
export * from "./ModalCadExame.vue?vue&type=script&lang=js"

import "./ModalCadExame.vue?vue&type=style&index=0&id=26152aaa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26152aaa"]])

export default __exports__